import React from "react";
import { connect } from "react-redux";
import {
  clearSelectedSynonym,
  fetchFunderContact,
  clearFunderContact,
  fetchSynonymsByParameter,
  selectFunderContact,
  selectFunderContactAffiliation,
  showModal,
} from "actions";
import {
  activeAgencySelector,
  activeFunderContactAffiliationFromFunderSelector,
  activeFunderIdSelector,
  loadingFundersSelector,
} from "reducers";
import Table from "components/table";
import IconLink from "components/IconLink";
import { FaEdit, FaTrash } from "react-icons/fa";
import { DELETE_FUNDER_CONTACT_AFFILIATION_MODAL, FUNDER_CONTACT_MODAL } from "components/modals";
import { isAdmin } from "permissions";

const FunderContactAffiliationTable = ({ funderContactsLoading, funderId, activeAgency, affiliations, ...props }) => {
  const columns = [
    {
      Header: "Action",
      className: "action",
      Cell: ({ row }) => {
        const id = row.original.id;
        return (
          <>
            <IconLink
              Icon={FaEdit}
              iconConfig={{ className: "table--action-icon" }}
              tooltip="View/Edit"
              onClick={() => {
                props.selectFunderContactAffiliation(id);
                if (row.original.funder_contact) {
                  props.fetchFunderContact(row.original.funder_contact);
                } else {
                  props.clearFunderContact();
                }
                props.showModal(FUNDER_CONTACT_MODAL);
              }}
            />
            <IconLink
              Icon={FaTrash}
              iconConfig={{ className: "table--action-icon btn--red" }}
              tooltip="Delete"
              onClick={() => {
                props.showModal(DELETE_FUNDER_CONTACT_AFFILIATION_MODAL, {
                  id: id,
                  activeFunderContactId: null,
                  activeFunderId: funderId,
                });
              }}
            />
          </>
        );
      },
    },
    {
      Header: "First Name",
      accessor: "first_name",
    },
    {
      Header: "Last Name",
      accessor: "last_name",
    },
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Funder",
      accessor: "funder_name",
    },
    {
      Header: "Company Email",
      accessor: "company_email",
    },
    {
      Header: "Company Phone",
      accessor: "company_phone",
    },
    {
      Header: "Mobile Phone",
      accessor: "mobile_phone",
    },
    {
      Header: "Status",
      accessor: "status",
    },
  ];

  return (
    <Table
      columns={columns}
      data={affiliations || []}
      emptyMessage={funderContactsLoading ? "Loading Funder Contacts data..." : "No Data"}
      showPaginationResults={true}
      defaultSort={true}
      paginated={false}
      initialPageSize={100}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    affiliations: activeFunderContactAffiliationFromFunderSelector(state),
    funderId: activeFunderIdSelector(state),
    activeAgency: activeAgencySelector(state),
    funderContactsLoading: loadingFundersSelector(state),
    hasAdminPermission: isAdmin(state),
  };
};

export default connect(mapStateToProps, {
  showModal,
  selectFunderContactAffiliation,
  selectFunderContact,
  clearSelectedSynonym,
  fetchFunderContact,
  clearFunderContact,
  fetchSynonymsByParameter,
})(FunderContactAffiliationTable);
